// Préfixes sous lesquels chaque app est montée. Source de vérité unique : le shell
// (src/index.tsx) les utilise comme segments de route, et les navigations internes les
// réutilisent via les helpers ci-dessous. Un seul BrowserRouter sans basename englobe les deux.
export const RM_BASENAME = '/request-manager';
export const HOME_BASENAME = '/home';

// Avec un routeur unique sans basename, les chemins absolus se résolvent à la racine du
// domaine. Les navigations internes (absolues depuis la racine de leur app) doivent donc
// être préfixées explicitement par le basename de l'app.
export const rmPath = (path = '') => `${RM_BASENAME}${path}`;
export const homePath = (path = '') => `${HOME_BASENAME}${path}`;
